import { useMemo, useState } from "react";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import { movies } from "@/mocks/movies";

const tabs = ["悬疑", "犯罪", "恐怖", "剧情", "科幻"];

export default function FeaturedMovies() {
  const [activeTab, setActiveTab] = useState("悬疑");

  const list = useMemo(() => {
    const filtered = movies.filter((movie) => movie.genre === activeTab);
    const rest = movies.filter((movie) => movie.genre !== activeTab);
    return [...filtered, ...rest].slice(0, 4);
  }, [activeTab]);

  return (
    <section className="w-full px-4 pt-14 md:px-8 md:pt-20">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="EDITOR'S PICK"
          title="精选电影专题"
          description="编辑部按类型整理的深夜片单，每一部都适合关掉灯、把音量调低一点再看。"
        />
        <div className="mb-6 flex flex-wrap items-center gap-1 rounded-full border border-background-800 bg-background-900/80 p-1 lg:mb-8">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(tab)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
                activeTab === tab
                  ? "bg-accent-500 font-medium text-background-950"
                  : "text-foreground-400 hover:text-foreground-100"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-4">
        {list.map((movie, index) => (
          <div
            key={movie.id}
            className="animate-rise"
            style={{ animationDelay: `${index * 70}ms` }}
          >
            <MovieCard
              id={movie.id}
              title={movie.title}
              year={movie.year}
              genre={movie.genre}
              region={movie.region}
              director={movie.director}
              duration={movie.duration}
              poster={movie.poster}
            />
          </div>
        ))}
      </div>
    </section>
  );
}